var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "aste" },
    [
      _c(
        "div",
        { staticClass: "toolbar", class: { dark: _vm.darkTheme } },
        [
          _c(
            "v-layout",
            { staticClass: "d-flex flex-row items-scroll selected-bar" },
            [
              _vm.config.aste_misure && _vm.sizesAvailables.length > 1
                ? _c(
                    "v-flex",
                    { staticClass: "misure-wrap select-layout" },
                    [
                      _c("v-combobox", {
                        attrs: {
                          "menu-props": { offsetY: true, top: false },
                          inputmode: "none",
                          clearable: "",
                          items: _vm.sizesAvailables,
                          "item-text": "name",
                          "item-value": "id",
                          dense: "",
                          "hide-selected": "",
                          "hide-details": "",
                          label: _vm.$t("message.Scegli_la_misura"),
                        },
                        model: {
                          value: _vm.templesSize,
                          callback: function ($$v) {
                            _vm.templesSize = $$v
                          },
                          expression: "templesSize",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.config.aste_material && _vm.dynamicMaterialOptions.length > 1
                ? _c(
                    "v-flex",
                    { staticClass: "misure-wrap select-layout uppercase" },
                    [
                      _c("v-select", {
                        attrs: {
                          "menu-props": {
                            offsetY: true,
                            top: false,
                            maxHeight: "20%",
                          },
                          items: _vm.dynamicMaterialOptions,
                          "item-text": "text",
                          "item-value": "id",
                          "return-object": false,
                          label: _vm.$t("message.Materiale"),
                          "hide-details": "",
                          dense: "",
                        },
                        model: {
                          value: _vm.materiale,
                          callback: function ($$v) {
                            _vm.materiale = $$v
                          },
                          expression: "materiale",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.config.aste_finiture
                ? _c(
                    "div",
                    { staticClass: "misure-wrap select-layout" },
                    [
                      _c("v-select", {
                        attrs: {
                          "menu-props": {
                            offsetY: true,
                            top: false,
                            maxHeight: "20%",
                          },
                          items: _vm.finituraOptions,
                          "item-text": "text",
                          "item-value": "id",
                          "return-object": false,
                          label: _vm.$t("message.Finitura"),
                          "hide-details": "",
                          dense: "",
                        },
                        model: {
                          value: _vm.finituraAste,
                          callback: function ($$v) {
                            _vm.finituraAste = $$v
                          },
                          expression: "finituraAste",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("div"),
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "center",
            "align-items": "center",
          },
        },
        [
          _c(
            "v-alert",
            {
              attrs: {
                value: _vm.noTempleAvailable(),
                type: "error",
                dismissible: "",
              },
            },
            [
              _c("span", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "message.Nessun_asta_corrispondente_alla_combinazione_colore_misura_materiale"
                      )
                    ) +
                    "! "
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c("ItemsCarousel", {
        attrs: {
          itemsType: _vm.itemsType,
          itemsCarousel: _vm.filteredTemples,
          itemsWrap: _vm.config.aste_wrap,
          activeElement: _vm.activeTempleCode,
        },
        on: { "item-selected": _vm.setActiveTemple },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }